/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { JobRfqDto } from './job-rfq.dto';
import { JobRfqMapper } from './job-rfq.mapper';

@Injectable()
export class JobRfqRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(jobId: ID): Observable<JobRfqDto> {
    return this.httpGet(
      `${this.bp}/jobs/${jobId}/rfq`,
      JobRfqMapper,
    );
  }

  update(jobId: ID, rfq: JobRfqDto): Observable<JobRfqDto> {
    return this.httpPut(
      `${this.bp}/jobs/${jobId}/rfq`,
      rfq,
      JobRfqMapper,
    );
  }
}
